/** author: 胡枭 */

import request from '@/utils/request.js'
import { isFormData } from 'jczh-ui/lib/jczh-ui.common'

// 用户密码登录
export function passwordLoginApi(data) {
  return request(
    {
      url: '/login',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    {
      isFormData: true
    }
  )
}

// 短信验证码登录
export function smsLoginApi(data) {
  return request(
    {
      url: '/login/sms',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    { isFormData: true }
  )
}

// 用户登录状态验证
export function checkApi() {
  return request({
    url: '/passport/status',
    method: 'get'
  })
}

// 退出登录
export function logoutApi() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 用户注册
export function registerApi(data) {
  return request(
    {
      url: '/register',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    { isFormData: true }
  )
}

// 专家注册
export function expertRegisterApi(data) {
  return request(
    {
      url: '/register/expert',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    { isFormData: true }
  )
}

// 查询手机号是否被注册
export function searchIfMobileOccupiedApi(params) {
  return request({
    url: '/users/mobile/exist',
    method: 'get',
    params
  })
}

// 忘记密码 -- 验证手机号
export function forgetPasswordVerifyMobileApi(data) {
  return request({
    url: '/users/forget/password',
    method: 'post',
    data
  })
}

// 忘记密码 -- 更新密码
export function forgetPasswordUpdateApi(data) {
  return request({
    url: `/users/forget/password/${data.sign}`,
    method: 'patch',
    data
  })
}

// 修改密码 (使用原密码修改)
export function editPasswordApi(data) {
  return request({
    url: '/users/oneself/password',
    method: 'patch',
    data
  })
}

// 更换绑定的手机号 -- 验证手机号
export function updateMobileVerifyApi(data) {
  return request({
    url: '/users/oneself/mobile',
    method: 'post',
    data
  })
}

// 更换绑定的手机号 -- 更新手机号
export function updateMobileApi(data) {
  return request({
    url: `/users/oneself/mobile/${data.sign}`,
    method: 'patch',
    data
  })
}

// 修改当前登录账号信息
export function editUserInfoApi(data) {
  return request({
    url: '/users/oneself/info',
    method: 'patch',
    data
  })
}

// 获取当前用户信息
export function getUserInfoApi() {
  return request({
    url: '/users/oneself',
    method: 'get'
  })
}

// 获取登录用户的身份，例如：专家身份、员工身份
export function getUserIdentityApi() {
  return request({
    url: '/passport/identity',
    method: 'get'
  })
}

// 授权凭据登录
export function loginByAccessTokenApi(data) {
  return request(
    {
      url: '/login/access-token',
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    },
    { isFormData: true }
  )
}

// 省投登录认证
export function jxicLoginApi(data) {
  return request(
    {
      url: '/passport/jxic',
      method: 'post',
      data
    },
    { isFormData: false }
  )
}

//  -------------------------- 微信操作接口 --------------------------
// 获取微信登录二维码
export function getWeChatQrCodeApi() {
  return request({
    url: '/passport/wechat/login-qr-code',
    method: 'get'
  })
}

// 微信扫码后检验是否登录
export function checkWeChatLoginApi(params) {
  return request({
    url: '/passport/wechat/check-login',
    method: 'get',
    params
  })
}

// 微信登录后创建账号密码
export function weChatLoginByAccountApi(data) {
  return request(
    {
      url: '/login/wechat',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    {
      isFormData: true
    }
  )
}

// 解绑微信
export function unbindWeChatApi() {
  return request({
    url: '/users/oneself/wx/mp/unbind',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取绑定微信二维码
export function getBindWechatQrCodeApi() {
  return request({
    url: '/users/oneself/wx/mp/bind/qr-code',
    method: 'get'
  })
}
